export const FormError = {
  baseStyle: {
    text: {
      fontSize: "sm",
      color: "brand.secondary",
    },
  },
}
